import { Pipe, PipeTransform } from '@angular/core';
import { IconLibraryTypes } from '@liberty-financial/ng-components/lib/components/icon/library.enum';

import { EntityType } from '@features/contacts/models';
import { Applicant } from '@features/opportunities/modules/applicant/services/applicant';
/*
 * Convert applicant type to svg icons.
 * Usage:
 *   applicantType | applicantIcon
 * @example
 * // returns doc icon
 * {{ 'doc' | applicantIcon }}
 */
@Pipe({
  name: 'applicantIcon'
})
export class ApplicantIconPipe implements PipeTransform {
  transform(applicantType: Applicant.Type | EntityType): IconLibraryTypes {
    switch (applicantType) {
      case Applicant.Type.Individual:
      case EntityType.Individual:
        return 'user';
      case Applicant.Type.Company:
      case EntityType.Company:
        return 'briefcase';
      case Applicant.Type.BareTrust:
      case Applicant.Type.SmsfTrust:
      case Applicant.Type.Trust:
      case EntityType.Trust:
        return 'handshake';
    }
  }
}
